@if (data?.length) {
    <div class="item-group">
        @for (activity of data; track activity) {
            @if (activity.section) {
                <tec-divider [label]="activity.title" />
            } @else {
                <tec-item
                    [tagImage]="activity.icon ? {icon: activity.icon} : undefined"
                    [tagIcon]="activity.status ? getTagIconItem(activity.status) : undefined"
                    [title]="stripHtml(activity.title)"
                    [clickeable]="false"
                    [detailAction]="activity.date | safeDate: 'dd/MM/yyyy - HH:mm'"
                >
                    @if (activity.showDeveloperCurl && canViewDeveloperCurl() && curlPath) {
                        <tec-button-icon
                            icon="icon-code-brackets"
                            type="default"
                            size="sm"
                            (clickEvent)="openCurlModal()"
                        />
                    }
                    @if (activity.description?.length) {
                        <tec-list-detail>
                            @for (description of activity.description; track $index) {
                                <span>{{ description }}</span>
                            }
                        </tec-list-detail>
                    }
                    @if (activity.tag) {
                        <tec-tag
                            [label]="activity.tag.label"
                            [status]="activity.tag.status"
                        />
                    }
                    @if (activity.link && canShowActivityLink(activity.link.action)) {
                        <tec-link
                            (click)="showActivityModal(activity.link.action, activity.link.info)"
                            [label]="activity.link.label"
                        />
                    }
                    @if (
                        (activity.showLogs || activity.link?.showLogs) &&
                        logs_url &&
                        rolePermissions.isSuperadmin()
                    ) {
                        <tec-link
                            [href]="logs_url"
                            target="_blank"
                            [label]="'PROCESSES.DETAIL.LOGS' | translate"
                        >
                            <tec-icon name="icon-open-web" size="xs" />
                        </tec-link>
                    }
                </tec-item>
            }
        }
    </div>
} @else {
    <tec-empty-state [title]="'PROCESSES.DETAIL.ACTIVITY_EMPTY' | translate" [size]="'default'" [type]="'empty'" />
}

@if (curlModalOpen()) {
    <app-modal-curl-request
        [titleKey]="curlTitleKey"
        [curlText]="curlModalText()"
        (closeEvent)="closeCurlModal()"
    />
}


@if (activityJsonModal) {
    <app-modal-json-viewer
        [title]="activityJsonModal.title"
        [json]="activityJsonModal.data"
        (closeEvent)="activityJsonModal = null"
    />
}

@if (formStepModal) {
    <tec-modal
        [isVisible]="!!formStepModal"
        [title]="formStepModal.title"
        (closeEvent)="formStepModal = null"
    >
        <ng-container body>
            <app-form-operation-detail-sections
                class="form-operation-detail-sections--activity"
                variant="activity"
                [sections]="formStepModalSections(formStepModal)"
            />
        </ng-container>
    </tec-modal>
}

@if (formMatchModal) {
    <tec-modal
        [isVisible]="!!formMatchModal"
        [title]="formMatchModalTitleKey(formMatchModal) | translate"
        (closeEvent)="formMatchModal = null"
    >
        <ng-container body>
            @if (formMatchModalHasMismatch(formMatchModal)) {
                <tec-alert
                    status="warning"
                    [msg]="formMatchModalAlertKey(formMatchModal) | translate"
                    [hiddenCloseButton]="true"
                />
            }
            <tec-table
                [headers]="[
                    { label: 'PROCESSES.DETAIL.FORM_MATCH_DATA_MODAL.TYPE' | translate },
                    { label: 'PROCESSES.DETAIL.FORM_MATCH_DATA_MODAL.FORM' | translate },
                    { label: 'PROCESSES.DETAIL.FORM_MATCH_DATA_MODAL.REFERENCE' | translate },
                ]"
                [rows]="formMatchModalRows(formMatchModal)"
                [config]="{ clickeable: false, borderless: true }"
            />
        </ng-container>
    </tec-modal>
}

@if (aeatModalOcr) {
    <tec-modal
        [isVisible]="!!aeatModalOcr"
        [title]="'PROCESSES.DETAIL.AEAT_MODAL.TITLE' | translate"
        (closeEvent)="aeatModalOcr = null"
    >
        <ng-container body>
            @if (aeatModalOcr?.antifraud?.AEAT === booleanStatus.KO) {
                <tec-alert
                    status="warning"
                    [msg]="'PROCESSES.DETAIL.AEAT_ERROR' | translate"
                    [hiddenCloseButton]="true"
                />
            }

            @if (aeatModalOcr?.actions?.AEAT?.details) {
                <tec-table
                    [headers]="[
                        { label: 'PROCESSES.DETAIL.AEAT_MODAL.TYPE' | translate },
                        { label: 'PROCESSES.DETAIL.AEAT_MODAL.DATA' | translate },
                        { label: 'PROCESSES.DETAIL.AEAT_MODAL.AEAT' | translate },
                    ]"
                    [rows]="aeatCompareRows(aeatModalOcr)"
                    [config]="{ clickeable: false, borderless: true }"
                />
            } @else {
                <tec-empty-state [title]="'GENERAL.NO_DATA' | translate" />
            }
        </ng-container>
    </tec-modal>
}

<!-- MODAL POLICY CHECKS -->
@if (policyModalInfo) {
    <tec-modal
        [isVisible]="true"
        [title]="'PROCESSES.DETAIL.LEGAL_TERM' | translate"
        (closeEvent)="policyModalInfo = null"
    >
        <ng-container body>
            <div class="grid grid-i3">
                <tec-info-group [label]="'PROCESSES.DETAIL.NAME' | translate">
                    <span>{{ policyModalName(policyModalInfo) }}</span>
                </tec-info-group>
                <tec-info-group [label]="'LEGAL_TERMS.REQUIRED' | translate">
                    <span>{{ policyModalInfo.required ? ('GENERAL.YES' | translate) : ('GENERAL.NO' | translate) }}</span>
                </tec-info-group>
                <tec-info-group [label]="'PROCESSES.DETAIL.POLICY_ORIGIN' | translate">
                    <span>{{ policyModalOrigin(policyModalInfo) }}</span>
                </tec-info-group>
            </div>

            <tec-tile>
                <span [innerHTML]="policyModalInfo.html"></span>
            </tec-tile>
        </ng-container>
    </tec-modal>
}
